export enum PessoaTipoInsercao {
    INTERNO = 'I',
    EXTERNO = 'E'
}
